import React from 'react';

const FilterBar = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange,
  onSearchChange
}) => {
  return (
    <div className="filter-bar">
      <div className="filter-header">
        
        <div className="search-container" style={{boxShadow:'none'}}>
            <div style={{width:'18px', height:'18px', position:'absolute', left:'20px',top:'13px'}}>
                <svg style={{color:'rgb(156, 163, 175)', fontSize:'18px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
            </div>
            <input
                type="text"
                placeholder="Search diplomas..."
                className="search-input"
                onChange={(e) => onSearchChange(e.target.value)}
            />
        </div>
      </div>
      
      <div className="category-filters">
        <button
          onClick={() => onCategoryChange(null)}
          className={`category-button ${selectedCategory === null ? 'active' : ''}`}
        >
          All
        </button>
        
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`category-button ${selectedCategory === category ? 'active' : ''}`}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;